import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Divider, message, Modal, Popconfirm, Table } from 'antd';
import moment from 'moment';

import { queryCancelRelate, queryFinancePayable, queryRelateDone } from '@api/incubator/finance';
import util from '@util/index';
import { setBackInfo } from '@store/modules/back_info';
import TableRelateDetail from './TableRelateDetail';

class TableRelated extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      detailList: {
        list: [],
        pagination: {},
      },
      data: {
        list: [],
        pagination: {},
      },

      statistics: {},
    };
  }

  componentDidMount() {
    const { backInfo } = this.props;
    if (backInfo.path === this.props.location.pathname) {
      this.current = backInfo.current;
    }
    this.condition = this.props.condition;
    this.getData();
  }

  componentWillReceiveProps(nextProps) {
    const { backInfo } = this.props;
    if (backInfo.path === this.props.location.pathname) {
      this.current = backInfo.current;
    }
    if (this.props.condition !== nextProps.condition) {
      this.condition = nextProps.condition;
      this.current = 1;
    }
    this.getData();
  }

  componentWillUnmount() {
    const params = {
      path: this.props.location.pathname,
      condition: this.condition,
      current: this.current,
      tabKey: this.props.tabKey,
    };
    this.props.dispatch(setBackInfo(params));
  }

  getData = () => {
    queryRelateDone({
      incubatorUuid: this.props.params.uuid,
      start: this.current || 1,
      ...this.condition,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: {
            list: res.data.data,
            pagination: {
              current: this.current,
              total: res.totalSize,
              pageSize: 15,
            },
          },
          statistics: res.data.statistics,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  handleTableChange = pagination => {
    this.current = pagination.current;
    this.getData();
  };

  // 流水匹配详情
  getDetail = () => {
    const pageSize = 5;
    queryFinancePayable({
      incomeUuid: this.uuid,
      start: this.current || 1,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          detailList: {
            list: res.data,
            pagination: {
              current: this.current,
              total: res.totalSize,
              pageSize,
            },
          },
        });
      } else {
        message.error(res.message);
      }
    });
  };

  // 资金取消关联客户
  cancelRelate = incomeUuid => {
    queryCancelRelate({
      incomeUuid,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.getData();
      } else {
        message.error(res.message);
      }
    });
  };

  handleDetailTableChange = pagination => {
    this.current = pagination.current;
    this.getDetail();
  };

  handleVisible = (flag, uuid) => {
    if (uuid) {
      this.uuid = uuid;
      this.getDetail();
    }
    this.setState({
      visible: !!flag,
    });
  };

  columns = () => {
    const { accountInfo, paymentTypes } = this.props;
    return [
      {
        title: '日期',
        dataIndex: 'date',
        width: 100,
        render: (text, record, index) => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '客户名称',
        dataIndex: 'customName',
        width: 150,
      },
      {
        title: '对方户名',
        dataIndex: 'accountName',
        width: 150,
      },
      {
        title: '金额',
        dataIndex: 'money',
        width: 100,
        render: (text, record) => (
          <span>{util.numberFormat(text === 0 ? record.payMoney : record.money)}</span>
        ),
      },
      {
        title: '类型',
        dataIndex: 'target',
        width: 80,
        render: (text, record) => <span>{text === 0 ? '支出' : '收入'}</span>,
      },
      {
        title: '收支类型',
        dataIndex: 'type',
        key: 'type',
        width: 150,
        render: (text, record) => {
          let typeName = '';
          if (paymentTypes.length > 0) {
            paymentTypes.forEach((item, index) => {
              if (text === item.value) {
                typeName = item.key;
                return typeName;
              }
            });
          }
          return <span>{typeName}</span>;
        },
      },
      {
        title: '已匹配金额',
        dataIndex: 'confirm',
        width: 120,
        render: (text, record) => <span>{util.numberFormat(record.confirm || 0)}</span>,
      },
      {
        title: '摘要',
        dataIndex: 'remark',
        width: 150,
      },
      {
        title: '操作',
        dataIndex: 'done',
        width: 200,
        render: (text, record) =>
          record.refundStatus === '0' ? (
            <span>
              <a onClick={() => this.handleVisible(true, record.uuid)}>匹配明细</a>
              {accountInfo.isHatcherMng ||
              accountInfo.isIncubatorMng ||
              accountInfo.isFinancialM ? (
                <span>
                  <Divider type="vertical" />
                  <Popconfirm
                    title="确认恢复关联吗？"
                    onConfirm={() => {
                      this.cancelRelate(record.uuid);
                    }}
                  >
                    <a>取消关联</a>
                  </Popconfirm>
                </span>
              ) : null}
            </span>
          ) : (
            <span>已退款</span>
          ),
      },
    ];
  };

  render() {
    const {
      visible,
      detailList,
      data: { list, pagination },
      statistics,
    } = this.state;
    return (
      <div>
        <div style={{ marginBottom: '16px', textAlign: 'right' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <div style={{ paddingRight: '8px', width: '250px', textAlign: 'left' }}>
              管理费已匹配金额：
              {util.numberFormat(statistics.doneIncomeSum || 0)}元
            </div>
            <div style={{ paddingRight: '8px', width: '250px', textAlign: 'left' }}>
              管理费待匹配金额：
              {util.numberFormat(statistics.todoIncomeSum || 0)}元
            </div>
            <div style={{ paddingRight: '8px', width: '250px', textAlign: 'left' }}>
              外部往来收入总计：
              {util.numberFormat(statistics.inOrOutIncomeSum || 0)}元
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <div style={{ paddingRight: '8px', width: '250px', textAlign: 'left' }}>
              退款已匹配金额：
              {util.numberFormat(statistics.doneExpenditureSum || 0)}元
            </div>
            <div style={{ paddingRight: '8px', width: '250px', textAlign: 'left' }}>
              退款待匹配金额：
              {util.numberFormat(statistics.todoExpenditureSum || 0)}元
            </div>
            <div style={{ paddingRight: '8px', width: '250px', textAlign: 'left' }}>
              外部往来支出总计：
              {util.numberFormat(statistics.inOrOutExpenditureSum || 0)}元
            </div>
          </div>
        </div>
        <Table
          rowKey="uuid"
          rowSelection={{}}
          columns={this.columns()}
          dataSource={list}
          pagination={pagination}
          onChange={this.handleTableChange}
        />
        <Modal
          title="匹配明细"
          visible={visible}
          footer={null}
          onCancel={() => this.handleVisible(false)}
          width={700}
        >
          <TableRelateDetail handleTableChange={this.handleDetailTableChange} data={detailList} />
        </Modal>
      </div>
    );
  }
}
export default connect(state => ({
  accountInfo: state.account_info,
  backInfo: state.back_info,
}))(TableRelated);



// WEBPACK FOOTER //
// ./src/components/incubator/income/TableRelated.js